import { render, staticRenderFns } from "./Paginator.vue?vue&type=template&id=c1ff613e&scoped=true"
import script from "./Paginator.vue?vue&type=script&lang=ts"
export * from "./Paginator.vue?vue&type=script&lang=ts"
import style0 from "./Paginator.vue?vue&type=style&index=0&id=c1ff613e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ff613e",
  null
  
)

export default component.exports